export default function video() {
  $('.wp-block-video').each(function () {
    const $block = $(this);
    const video = $(this).find('video');
    if (!video.attr('autoplay')) {
      const bg = video.attr('poster');
      $block.append("<div class='wp-block-video__hover' style='background-image:url(" + bg + ")'></div>");
      const $hover = $block.find('.wp-block-video__hover');
      $hover.click(function () {
        $hover.css('backgroundImage', '');
        $block.toggleClass('wp-block-video--playing');
        if ($block.hasClass('wp-block-video--playing')) {
          video.get(0).play();
        } else {
          video.get(0).pause();
        }
      });
    }
  });
}
